<template>
    <button type="submit" class="btn btn-primary">
        {{ $t("crud:button.save") }}
    </button>
</template>
